﻿import * as restDemographics from "@esri/arcgis-rest-demographics";
import esriRequest from "@arcgis/core/request";

export default class ArcGisRestWrapper {
    private dotNetRef: any;
    
    constructor(dotNetRef) {
        this.dotNetRef = dotNetRef;
    }

    async queryDemographicData(point, apiKey) {
        try {
            let response = await restDemographics.queryDemographicData({
                studyAreas: [{
                    "geometry": {
                        "x": point.longitude,
                        "y": point.latitude
                    }
                }],
                authentication: apiKey
            });
            if (response?.results !== null &&
                response.results[0].value.FeatureSet.length > 0 &&
                response.results[0].value.FeatureSet[0].features.length > 0) {
                return response.results[0].value.FeatureSet[0].features;
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
    
    async request(url, options) {
        try {
            let response = await esriRequest(url, options);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
}
